import axios from './HTTP'

export default {
  getMine (callback) {
    axios
      .get('/api/my-invites.json')
      .then(response => ( callback(response.data) ))
  },

  getMineInRange ({ from, to }, callback) {
    axios
      .get('/api/my-invites/range.json', { params: { from, to } })
      .then(response => ( callback(response.data) ))
      .catch(() => ( callback([]) ))
  },

  rsvpForEvent (eventID, callback) {
    axios
      .get(`/api/events/${ eventID }/my-rsvp.json`)
      .then(response => ( callback(response.data) ))
  },

  respond({ eventId, going }) {
    return axios.post(`/api/events/${ eventId }/my-rsvp.json`, { going })
      .then(rsvp => {
        return rsvp.data
      })
      .catch((e) => {
        throw e
      })
  },

  clockIn({ eventId }) {
    return axios.post(`/api/events/${ eventId }/clock-in.json`)
      .then(rsvp => {
        return rsvp.data
      })
      .catch((e) => {
        throw e
      })
  },

  clockOut({ eventId }) {
    return axios.post(`/api/events/${ eventId }/clock-out.json`)
      .then(rsvp => {
        return rsvp.data
      })
      .catch((e) => {
        throw e
      })
  },
}
